import { useState } from 'react';

import { useUserProfileOptions } from './useUserProfileOptions';
import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useTranslation } from '../../hooks/useTranslation';
import { useIsCatalogESIndex } from '../../hooks/useIsCatalogESIndex';
import { useQueryStateContext } from '../../contexts';

type UserProfileSelectProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  isInvalid?: boolean;
};

export const UserProfileSelect = ({ onChange, value, isInvalid }: UserProfileSelectProps) => {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const { UserProfileSelect: VisualComponent, ConditionValueLoadingSelect: LoadingComponent } =
    useVisualComponentsContext();
  const { options, didError, isLoading } = useUserProfileOptions({ search });
  const { isReadOnly = false } = useQueryStateContext();
  const isCatalogESIndex = useIsCatalogESIndex();

  const hasError = isInvalid || didError;
  const isDisabled = didError || isLoading || isReadOnly;

  const placeholder = isCatalogESIndex
    ? t('v2.conditionBuilder.catalogFieldPlaceholder')
    : t('v2.conditionBuilder.singleUserProfileFieldPlaceholder');

  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <VisualComponent
          onChange={onChange}
          options={options}
          search={search}
          setSearch={setSearch}
          value={value}
          hasError={hasError}
          isDisabled={isDisabled}
          placeholder={placeholder}
          isVirtualized
        />
      )}
    </>
  );
};
